<template>
  <div>
    <NavBar />
    <div class="app-sidebar__overlay" data-toggle="sidebar"></div>
    <SideBar />
    <main class="app-content">
      <router-view />
    </main>
  </div>
</template>

<script>
import $ from 'jquery';
import NavBar from '../common/NavBar.vue';
import SideBar from '../common/SideBar.vue';

export default {
  name: 'MainLayout',
  components: {
    NavBar,
    SideBar,
  },
  mounted() {
    var treeviewMenu = $('.app-menu');

    // Toggle Sidebar
    $('[data-toggle="sidebar"]').click(function (event) {
      event.preventDefault();
      $('.app').toggleClass('sidenav-toggled');
    });

    // Activate sidebar treeview toggle
    $("[data-toggle='treeview']").click(function (event) {
      event.preventDefault();
      if (!$(this).parent().hasClass('is-expanded')) {
        treeviewMenu.find("[data-toggle='treeview']").parent().removeClass('is-expanded');
      }
      $(this).parent().toggleClass('is-expanded');
    });
  },
  data() {
    return {
      // isSidebarOpen: true means the sidebar is visible (default state in your HTML seems open)
      // When 'sidenav-toggled' class is present, it means the sidebar is collapsed.
      // So, if isSidebarOpen is true, sidenav-toggled should be false.
      // If isSidebarOpen is false, sidenav-toggled should be true.
      isSidebarOpen: true, // Initialize based on your default layout state
    };
  },
};
</script>

<style>
.app-content {
  justify-content: center;
}
/* You'll still need your original CSS for .app, .sidenav-toggled, etc. */
/* @import './assets/css/main.css'; is likely already in App.vue or main.js */
</style>